import { createRequest } from './createRequest'

export const confirmPassword = createRequest({
  path: '/confirm-password',
})
